export default {
  navigation: {
    next: 'Próximo',
    back: 'Voltar',
    surveyNavigation: 'Navegação do questionário',
    workspace: {
      home: 'Início',
      example: 'Exemplo'
    }
  }
}
